import { useAuthentication } from '@/hooks/useAuthentication';
import { useSuspenseQuery } from '@apollo/client';
import { MissionQuery, MissionQueryVariables, FETCH_MISSION } from '@edwin-group/cj-graphql';
import { useEffect } from 'react';
import { GetCurrentSchoolYearUseCase } from '../../use-cases/get-current-school-year';
import { useMissionStore } from '../store/useMissionStore';
import { useMissionRouteParams } from './useMissionRouteParams';
import { useMissionDetailingStore } from '../../detailing/store/useMissionDetailingStore';

export const useMission = () => {
  const { missionSlug } = useMissionRouteParams();
  const setMission = useMissionStore((state) => state.setMission);
  const setMissionPage = useMissionDetailingStore((state) => state.setMissionPage);

  const { schoolContext } = useAuthentication();

  const { data: missionResult, error: missionError } = useSuspenseQuery<MissionQuery, MissionQueryVariables>(
    FETCH_MISSION,
    {
      variables: {
        slug: missionSlug!,
        schoolDocumentId: schoolContext?.documentId || '',
        schoolYear: GetCurrentSchoolYearUseCase.execute(),
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    if (missionResult) {
      setMission(missionResult);
      setMissionPage(missionResult);
    }
  }, [missionResult, setMission, setMissionPage]);

  return {
    missionResult,
    errors: [missionError].filter(Boolean),
  };
};
